<div class="row animated fadeIn">
    <div class="col-md-12">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h4 class="mb-0"><a href="javascript:void(0);" routerLink="/productmanagment/productlist"><span
                        class="mdi mdi-arrow-left"></span></a> Edit Master Product</h4>
        </div>

        <div class="card">
            <div class="card-body">
                <form [formGroup]="registerForm">
                    <div class="form-row">
                        <div class="form-group mb-1 col-lg-3 col-md-3 col-sm-12">
                            <label class="col-form-label pt-0">Business Vertical</label>
                            <input class="form-control-plaintext ng-pristine ng-valid ng-touched" type="text"
                                placeholder={{business}} formControlName="BusinessVertical" readonly />
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-bordered mt-3 mat-table" aria-hidden="true">
                            <thead class="thead-light">

                                <tr>
                                    <th *ngFor="let col of ProductHeader; index as i;" id="tab-selectbyid-{{i+1}} "
                                        class="font-weight-bold">{{col}} <span
                                            *ngIf="col!=='Brand' && col!=='Product Series' && col!=='Vat %' && col!='HVAC/ Project Series' && col!='MEP/ Project Series' && col!='Product/ Spare Series' && col!='Product/ Service Series' && col!='Product/ Installation Series'"
                                            class="required">*</span>
                                    </th>
                                </tr>
                            </thead>

                            <tbody *ngIf="isRender">
                                <tr>

                                    <td style="min-width:180px;">
                                        <angular2-multiselect [data]="detailStream" [(ngModel)]="selectedDetail"
                                            [settings]="dropdownSettings" formControlName="BusinessCategory"
                                            (onSelect)="onDetailSelect($event)" (onDeSelect)="onDetailSelect($event)"
                                            fixSearchBug>
                                        </angular2-multiselect>
                                        <div *ngIf="submitted && registerForm.controls.BusinessCategory.errors">
                                            <span style="color:red !important; font-size: 10px;">
                                                Category is required</span>
                                        </div>
                                    </td>

                                    <td style="min-width:195px;">
                                        <mat-form-field class="example-full-width" appearance="fill">
                                            <input type="text" placeholder="Product Group" aria-label="text" matInput
                                                maxlength="50" [(ngModel)]="selectedGroup"
                                                class="form-control example-no-focus py-0"
                                                formControlName="ProductGroupName" [matAutocomplete]="auto"
                                                (input)="NewSearchFun($event,1)">
                                            <mat-autocomplete #auto="matAutocomplete">
                                                <mat-option *ngFor="let option of productGroupHd | async"
                                                    [value]="option">
                                                    {{option}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                        <div *ngIf="submitted && registerForm.controls.ProductGroupName.errors">
                                            <span style="color:red !important; font-size: 10px;">
                                                Group is required</span>
                                        </div>
                                    </td>

                                    <td style="min-width:180px;">
                                        <mat-form-field class="example-full-width" appearance="fill">
                                            <input type="text" placeholder="Product Type" aria-label="text" matInput
                                                (input)="NewSearchFun($event,2)" maxlength="50"
                                                [(ngModel)]="selectedType" class="form-control example-no-focus py-0"
                                                formControlName="ProductTypeName" [matAutocomplete]="auto1">
                                            <mat-autocomplete #auto1="matAutocomplete">
                                                <mat-option *ngFor="let option of ProductTypeNm | async"
                                                    [value]="option">
                                                    {{option}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                        <div *ngIf="submitted && registerForm.controls.ProductTypeName.errors">
                                            <span style="color:red !important; font-size: 10px;">
                                                Type is required</span>
                                        </div>
                                    </td>

                                    <td style="min-width:180px;">
                                        <mat-form-field class="example-full-width" appearance="fill">
                                            <input type="text" placeholder="Brand" aria-label="text" maxlength="50"
                                                class="form-control example-no-focus py-0" matInput
                                                [(ngModel)]="selectedBrand" formControlName="ProductBrandName"
                                                [matAutocomplete]="auto2" (input)="NewSearchFun($event,3)">
                                            <mat-autocomplete #auto2="matAutocomplete">
                                                <mat-option *ngFor="let option of Brand | async" [value]="option">
                                                    {{option}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </td>

                                    <td style="min-width:180px;">
                                        <mat-form-field class="example-full-width" appearance="fill">
                                            <input type="text" placeholder="Product Series" aria-label="text" matInput
                                                (input)="NewSearchFun($event,4)" maxlength="100"
                                                [(ngModel)]="selectedSeries" class="form-control example-no-focus py-0"
                                                formControlName="ProductSeriesName" [matAutocomplete]="auto3">
                                            <mat-autocomplete #auto3="matAutocomplete">
                                                <mat-option *ngFor="let option of Series | async" [value]="option">
                                                    {{option}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </td>

                                    <td style="min-width:180px;">
                                        <mat-form-field class="example-full-width" appearance="fill">
                                            <input type="text" placeholder="Equipment Type" aria-label="text" matInput
                                                (input)="NewSearchFun($event,5)" maxlength="50"
                                                [(ngModel)]="selectedPro" class="form-control example-no-focus py-0"
                                                formControlName="Type" [matAutocomplete]="auto4">
                                            <mat-autocomplete #auto4="matAutocomplete">
                                                <mat-option *ngFor="let option of Pro | async" [value]="option">
                                                    {{option}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                        <div *ngIf="submitted && registerForm.controls.Type.errors">
                                            <span style="color:red !important; font-size: 10px;">
                                                Equipment Type is required</span>
                                        </div>
                                    </td>

                                    <td style="min-width:180px;"><input type="text" class="form-control"
                                            formControlName="ItemCode" maxlength="100" placeholder="Item Code"
                                            (input)="NameSpaceNotAllowed($event)">
                                        <div *ngIf="submitted && registerForm.controls.ItemCode.errors">
                                            <span style="color:red !important; font-size: 10px;">
                                                Code is required</span>
                                        </div>
                                    </td>

                                    <td style="min-width:180px;"><input type="text"
                                            (input)="NameSpaceNotAllowed($event)" class="form-control"
                                            placeholder="Description" formControlName="Description" maxlength="100">
                                        <div *ngIf="submitted && registerForm.controls.Description.errors">
                                            <span style="color:red !important; font-size: 10px;">
                                                Description is required</span>
                                        </div>
                                    </td>

                                    <td style="min-width:95px;">
                                        <select class="form-control" formControlName="IsVatAllow"
                                            (change)="onVatSelect($event)">
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                    </td>

                                    <td style="min-width:100px;" *ngIf="disableValue">
                                        <input type="text" class="form-control" formControlName="VatRate"
                                            maxlength="99.99" placeholder="VatRate" maxlength="6" max="99.99"
                                            appTwoDigitDecimaNumber (keyup)="getPrice()"
                                            (input)="NameSpaceNotAllowed($event); vatR($event)">
                                        <div *ngIf="submitted && registerForm.controls.VatRate.errors">
                                            <span style="color:red !important; font-size: 10px;">
                                                VatRate is required</span>
                                        </div>
                                    </td>

                                    <td style="min-width:100px;" *ngIf="!disableValue">
                                        <input type="text" class="form-control" formControlName="VatRate"
                                            placeholder="VatRate" disabled>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="row justify-content-end align-items-center mb-2 zIndexUp">
                        <ul
                            class="list-unstyled action-tool-bar col-xl-auto col-lg-auto col-md-10 col-sm-12 mb-0 d-flex align-items-center flex-wrap">
                            <li> <button *ngIf="!multiClick" href="javascript:void(0);"
                                    class="btn btn-sm btn-light-info" (click)="onSubmit()"><span
                                        class="mdi mdi-content-save"></span>Save</button>
                                <button *ngIf="multiClick" href="javascript:void(0);" class="btn btn-sm btn-light-info"
                                    [disabled]="multiClick"><span class="mdi mdi-content-save"></span>Save</button>
                            </li>
                        </ul>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <ngx-spinner type="ball-scale-multiple"></ngx-spinner>